import React from 'react';
import InputMask from 'react-input-mask';
import TextField from '@material-ui/core/TextField';

// Generic Masked Input component
const MaskedInputField = ({
  mask,
  formatChars,
  value,
  onChange,
  label,
  beforeMaskedValueChange,
  maskChar = '_',
  textFieldProps,
	showMask = false,
	maskPlaceholder = null,
  placeholder = null,
}) => (
  <InputMask
    mask={mask}
    formatChars={formatChars}
    maskChar={maskChar}
    value={value}
    onChange={onChange}
    beforeMaskedValueChange={beforeMaskedValueChange}
		alwaysShowMask={showMask}
		maskPlaceholder={maskPlaceholder}
    placeholder={placeholder}
  >
    {(inputProps) => (
      <TextField
        {...inputProps}
        label={label}
        variant="outlined"
        fullWidth
        {...textFieldProps}
      />
    )}
  </InputMask>
);

export default MaskedInputField;
